import { of } from 'rxjs';

export class ImpersonateRolesServiceMock {
  public static isAuthorized = function () {
    return of(true);
  };
}
